/*
 * Module for the Benefit Insurance Changes criteria page
 */

rs.module("content/reports/benefitinsurancechangescriteria",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the page
        function initialize(jsSelectors, backendUrl) {

            var criteria = $.js(jsSelectors.criteria);

            var typeSelect = criteria.js(jsSelectors.typeSelect);
            var carrierSelect = criteria.js(jsSelectors.carrierSelect);

            // Get Select Helper for carrierSelect since we're updating its options and properties
            var carrierSelectHelper = selectHelper.getHelper(carrierSelect);

            typeSelect.change(insuranceTypeChanged);

            enableDisableFields();

            // On type change, handle population of associated carriers
            function insuranceTypeChanged() {

                var typeSpecified = typeSelect.val() !== "";

                if (typeSpecified) {

                    // get selected type
                    var selectedTypeCd = typeSelect.val();

                    // populate carriers based on selected type
                    carrierSelectHelper.loadOptionsFrom(backendUrl, { insuranceType: selectedTypeCd }, { withBlank: true });

                } else {

                    carrierSelectHelper.clearOptions();
                }

                enableDisableFields();
            }

            // enable or disable carrier drop down based on whether or not a type is selected
            function enableDisableFields() {

                var allTypes = typeSelect.val() === "";

                // enable/disable carrier select based on type selected
                carrierSelectHelper.setDisabled(allTypes);
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);